module.exports = __webpack_public_path__ + "static/wuelto2.6a517236.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/wuelto2.png
// module id = 1264
// module chunks = 35783957827783